<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
<!--                <m-search-item label="年份">
                    <c-input name="year" maxlength="50"></c-input>
                </m-search-item>-->
                <m-search-item label="名称">
                    <c-input name="holiday_name" maxlength="50"></c-input>
                </m-search-item>
                <m-search-item label="类型">
                    <c-select name="holiday_types" :options="holidayTypeDic" multiple></c-select>
                </m-search-item>
            </m-search>

            <m-operate :batch="batchData.length" @batchCancel="batchCancel">
                <c-button color="main" v-if="auth('b_holiday_config_edit')" prepend-icon="tf-add" @click="edit()">创建节假日</c-button>

                <template #batch>
                    <c-button v-if="auth('b_holiday_config_edit')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemove">批量删除</c-button>
                </template>
            </m-operate>

            <c-table ref="list" height="grow" :paging="true">
                <c-table-column
                        type="selector"
                        width="32"
                        @handle="batchSelect"
                ></c-table-column>

                <c-table-column
                        label="节假日名称"
                        name="holiday_name"
                        width="120"
                >
                </c-table-column>

                <c-table-column
                        label="节假日类型"
                        name="holiday_type"
                        width="120"
                >
                    <template #default="{data}">
                        <c-state dict="holidayTypeDic" tag :value="data.holiday_type"></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                        label="起止时间"
                        width="200"
                >
                    <template #default="{data}">
                        {{data.start_date}} ~ {{data.end_date}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="备注"
                        name="remark"
                        width="300"
                >
                    <template #default="{data}">
                        <span v-if="data.remark">{{data.remark}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="创建人"
                        name="create_user_realname"
                        width="110"
                >
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="110"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_holiday_config_edit')" icon="tf-edit" @click="edit(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_holiday_config_edit')" icon="tf-trash" @click="remove(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <!--创建/编辑单位信息弹窗-->
            <holiday-edit ref="holidayEdit" @resolve="$refs.list.update()"></holiday-edit>
        </module>
    </page>
</template>

<script>
import holidayEdit from "@/pages/system/holiday_edit.vue";
import {mapState} from "vuex";
import {batchData, batchMethods} from "@/components/public/batch";

export default {
    components: {
        holidayEdit
    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['holidayTypeDic'])
    },
    props: {
        type: String
    },

    data() {
        return {
            ...batchData()
        }
    },

    mounted() {
        this.searchHandle();
    },

    methods: {
        ...batchMethods(),

        /********搜索************/
        searchHandle(data){
            if (!data){
                data = {};
            }
            this.$refs.list.load({
                url: '/holiday/calendar/list',
                data,
                success: () => {}
            });
        },

        /******新建/编辑单位*******/
        edit(data) {
            this.$refs.holidayEdit.open(data);
        },

        /****批量删除单位****/
        batchRemove(){
            var ids = [];
            this.$refs.list.getData('selected').forEach(item => {
                ids.push(item.id);
            });

            this.$confirm({
                message:'确认删除' + ids.length + '条节假日记录吗？删除后不可恢复',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/holiday/calendar/remove',
                        data: {ids: ids},
                        loading: true,
                        success: data => {
                            //刷新
                            this.$refs.list.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        },

        /******删除单位***********/
        remove(data){
            this.$confirm({
                message:'确认删除单位【'+data.holiday_name+'】？删除后不可恢复',  // 提示内容,
                // buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/holiday/calendar/remove',
                        data: {id:data.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                message:'删除成功',  // 提示内容,
                                type: 'success'
                            });
                            this.$refs.list.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>